// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixWindow from 'wix-window';
$w.onReady(function () {
	if (wixWindow.formFactor === "Desktop") {
		$w("#navMenu").show();
		$w("#bread").show();
	} else {
		$w("#pageTitle").text = "News";
		$w("#pageTitle").show();
	}

});